import React from 'react';
import ReactDOM from 'react-dom/client';
import './setupProdConsoleSilence';
import App from './App';
import './index.css';
import '@toast-ui/editor/dist/toastui-editor.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
